import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  ROUTER_PATHS,
  gridSizeMdLg4,
  newGastosSchema,
} from "@/shared";
import {
  useFetchIvas,
  usefetchProveedor,
  useFetchICEAll,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,

  SingleTableBoxScene,
  CustomNumberTextField,
  SampleCheckbox,
  CustomTextField,
} from "@/shared/components/ui";
import {
  IVA,
  PROVEEDOR,
  ICE,
} from "@/shared/interfaces";
import {
  Grid,
  TextField,
} from "@mui/material";
import { useUiStore } from "@/store/ui";
import { Gastos } from "@/shared/interfaces/erp/inventario";
import { useCreateGasto, useUpdateGasto } from "@/shared/actions/erp/inventario/gastos.actions";
import PlanCuentaGastoComponente from "../../plan-cuentas-gastos/planCuentaGastosComponente";
import { CuentasContablesKey, useCuentasContablesStore } from "@/store/erp/shared/gastos.store";

const returnUrlGastos = ROUTER_PATHS.inventario.gastos_nav;
export interface SaveGastosProps {
  titlePage: string;
  editGastos?: Gastos;
}

type SaveFormData = {
  codigo: string;
  nombre: string;
  descripcion: string;
  iva: string;
  ice: string;
  costo: string;
  estado: boolean;
  proveedor: string;
  cuentas_contables?: string[];
};

const SaveGastos: React.FC<SaveGastosProps> = ({
  editGastos,
}) => {
  const navigate = useNavigate();
  ///* local state
  const [shrink, setShrink] = useState(false);
  const selectedCuentasContables = useCuentasContablesStore(s => s.cuentasContables);
  const clearAllCuentasContables = useCuentasContablesStore(s => s.clearSelectedCuentasContables);
  const addSelectedCuentasContables = useCuentasContablesStore(s => s.setSelectedCuentasContables);

  ///* fetch data


  const { data: IVAPaging } =
    useFetchIvas({
      page_size: 600,
    });
  const { data: ICEPaging } =
    useFetchICEAll({
      page_size: 600,
    });
  const { data: ProveedorPaging, isLoading: isLoadingProveedor } =
    usefetchProveedor({
      page_size: 600,
    });
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newGastosSchema),
    defaultValues: { estado: false },
  });

  const {
    handleSubmit,
    control,
    register,
    reset,
    formState: { errors, isValid },
  } = form;
  ///* mutations
  const createGastos = useCreateGasto({ navigate, returnUrl: returnUrlGastos });
  const updateGastos = useUpdateGasto({ navigate, returnUrl: returnUrlGastos });
  ///* handlers

  const onSave = () => {
    if (!isValid) return;
    try {
      if (editGastos?.id_gasto) {
        return updateGastos.mutate({
          id: editGastos.id_gasto,
          data: { ...form.getValues() as any },
        });
      } else {
        return createGastos.mutate(
          {
            ...form.getValues() as any,
            cuentas_contables: JSON.stringify(selectedCuentasContables),
          },
          {
            onSuccess: () => {
              clearAllCuentasContables(CuentasContablesKey.cuentasContables);
            },
          }
        );
      }
    }
    catch (error) {
      console.log(error);
    }
  };
  const onChangeProveedor = (value: string) => {
    form.setValue("proveedor", value);
  };
  const onChangeICE = (value: string) => {
    form.setValue("ice", value);
  };
  const onChangeIVA = (value: string) => {
    form.setValue("iva", value);
  };
  useEffect(() => {
    if (editGastos) {
      setShrink(true);
      reset({
        ...editGastos
      } as any);
      const cuentasContables = JSON.parse(editGastos.cuentas_contables);
      addSelectedCuentasContables(cuentasContables, CuentasContablesKey.cuentasContables);
    }
    if (!editGastos) {
      clearAllCuentasContables(CuentasContablesKey.cuentasContables);
    }
  }, [editGastos]);
  const setAlert = useUiStore((s) => s.setAlert);
  return (
    <>
      <SingleTableBoxScene
        title="Gastos"
        enableBackBtn={true}
        backPageUrl="/inventario/gastos"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {
          setAlert(true, "Faltan campos por llenar", "error");
        })}
      >
        <Grid container spacing={3}>
          <CustomTextField
            name="codigo"
            label="Codigo"
            control={form.control}
            defaultValue={form.getValues().codigo || ""}
            error={errors.codigo}
            helperText={errors.codigo?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            name="nombre"
            label="Nombre"
            control={form.control}
            defaultValue={form.getValues().nombre || ""}
            error={errors.nombre}
            helperText={errors.nombre?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />

          <CustomNumberTextField
            label="Costo"
            name="costo"
            control={form.control}
            defaultValue={form.getValues().costo || ''}
            error={errors.costo}
            helperText={errors.costo?.message ?? ''}
            shrink={shrink}
            min={0}
            max={100}
            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<IVA>
            label="IVA"
            name="iva"
            // options
            options={IVAPaging?.data.data || []}
            valueKey="nombre" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().iva || ""}
            isLoadingData={isLoadingProveedor}
            control={control}
            error={errors.iva}
            helperText={errors.iva?.message}
            onChangeValue={onChangeIVA}
            size={gridSizeMdLg4}
            optionLabelForEdit={
              IVAPaging?.data.data
                .find(
                  (z: any) =>
                    z.id_iva === form.getValues().iva
                )
                ?.id_iva?.toString() || ""
            }
          />

          <CustomAutocomplete<ICE>
            label="ICE"
            name="ice"
            // options
            options={ICEPaging?.data.data || []}
            valueKey="nombre" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().ice || ""}
            isLoadingData={isLoadingProveedor}
            control={control}
            error={errors.ice}
            helperText={errors.ice?.message}
            onChangeValue={onChangeICE}
            optionLabelForEdit={
              ICEPaging?.data.data
                .find(
                  (z: any) =>
                    z.id_ice === form.getValues().ice
                )
                ?.id_ice?.toString() || ""
            }
            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<PROVEEDOR>
            label="Proveedor"
            name="proveedor"
            // options
            options={ProveedorPaging?.data.data || []}
            valueKey="razon_social" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().proveedor || ""}
            isLoadingData={isLoadingProveedor}
            control={control}
            error={errors.proveedor}
            helperText={errors.proveedor?.message}
            onChangeValue={onChangeProveedor}
            optionLabelForEdit={
              ProveedorPaging?.data.data
                .find(
                  (z: any) =>
                    z.id_proveedor === form.getValues().proveedor
                )
                ?.id_proveedor?.toString() || ""
            }
            size={gridSizeMdLg4}
          />
          <Grid item {...gridSizeMdLg4}>
            <TextField
              {...register("descripcion", {
                required: "La descripcion es obligatoria",
              })}
              id="descripcion"
              label="Descripción"
              fullWidth
              rows={4}
              multiline
              error={Boolean(errors.descripcion)}
              helperText={errors.descripcion?.message}
            />
          </Grid>
          <Grid item {...gridSizeMdLg4}>
            <SampleCheckbox
              label="Estado"
              name="estado"
              control={form.control}
              defaultValue={!!form.getValues().estado || false}
              isState
            />
          </Grid>
          <Grid item container justifyContent="center" alignItems="center">
            <PlanCuentaGastoComponente
              control={control}
            />
          </Grid>
        </Grid>
      </SingleTableBoxScene>
    </>

  );
}
export default SaveGastos;
